import { ThemeProvider } from '@emotion/react';
import { Avatar, Chip } from '@mui/material';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { createTheme, styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import * as React from 'react';

const colortheme = createTheme({
  palette: {
    primary: {
      main: '#292739',
    },
  },
  typography: {
    fontFamily: ['lato'].join(','),
  },
});

const ParaText = styled(Typography)(({ theme }) => ({
  fontSize: '1rem',
  color: '#ffffff',
}));

const TitleText = styled(Typography)(({ theme }) => ({
  fontSize: '2.4rem',
  fontWeight: 'bold',
  color: '#ffffff',
}));

const RewardCard = styled(Box)(({ theme }) => ({
  background: 'linear-gradient(100deg, #325e6a, #313646)',
  padding: '3rem',
  borderRadius: '30px',
  marginBottom: '1rem',
  boxShadow: colortheme.shadows[4],
  position: 'relative',
  overflow: 'hidden',
  // #325e6a
  // #313646
  //shadow rgba(0,0,0,0.10196078431372549 )
}));
const RewardCardLayer = styled(Box)(({ theme }) => ({
  backgroundColor: "#C2CEED",
  borderRadius: "100% 75% 30px 30px",
  boxShadow: colortheme.shadows[4],
  position: "absolute",
  top: "50%",
  left: '50%',
  width: "120%",
  height: "50%",
  opacity: "0.05",
  zIndex: "0",
  transform: "translate(-50%)",
  /* overflow: hidden; */
}));

const RewardCardSmallLayer = styled(RewardCardLayer)(({ theme }) => ({
  borderRadius: "250% 50% 30px 30px",
  left: '50%',
  width: "150%",
  height: "250%",
}));

const SmallRewardCard = styled(RewardCard)(({ theme }) => ({
  background: 'linear-gradient(100deg, #325e6a, #313646)',
  padding: '1.5rem',
  borderRadius: '30px',
  marginBottom: '1rem',
  boxShadow: colortheme.shadows[4],

  // #325e6a
  // #313646
  //shadow rgba(0,0,0,0.10196078431372549 )
}));

const LightChip = styled(Chip)(({ theme }) => ({
  backgroundColor: 'rgba(0,0,0,.1)',
  color: '#fff',
  fontSize: '.9rem',
  padding: '1.5rem .8rem',
  borderRadius: '25px',
  height: '2rem',
  '& .MuiAvatar-root img': {
    width: '25px',
    height: '25px',
  },
}));

const ProfileImg = styled('img')(({ theme }) => ({
  objectFit: 'cover',
  width: '250px',
  height: '250px',
  borderRadius: '50%',
  zIndex: "1",
  [colortheme.breakpoints.down('md')]: {
    width: '150px',
    height: '150px',
  },
}));

const AvmBody = () => {
  const useravatar = require('assets/Profile/buku_default_avatar.png');
  const moneyIcon = require('assets/icons/money.svg');
  return (
    <React.Fragment>
      <ThemeProvider theme={colortheme}>
        <Box>
          <TitleText style={{ fontSize: '1.4rem', margin: '1.8rem 0rem' }}>
            My Activity
          </TitleText>
          <RewardCard>
            <RewardCardLayer></RewardCardLayer>

            <Grid
              container
              sx={{
                alignItems: 'center',
                marginBottom: '1rem',
                zIndex: '2',
                position: 'relative',
              }}
            >
              <Grid item xs={6}>
                <TitleText style={{ fontSize: '1.4rem' }}>
                  1. Your top creator of the month
                </TitleText>
              </Grid>
              <Grid item xs={6} sx={{ textAlign: 'end' }}>
                <ParaText
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'end',
                    color: '#ddb930',
                  }}
                >
                  <img
                    src={moneyIcon.default}
                    alt="money Icon"
                    width={20}
                    height={20}
                    style={{ marginRight: '.4rem' }}
                  />
                  PAYS OUT 300 AVM
                </ParaText>
              </Grid>
            </Grid>

            <Grid container>
              <Grid item xs={12}>
                <LightChip
                  avatar={<Avatar alt="@leahx1621" src={useravatar} />}
                  label="@leahx1621"
                  style={{ marginLeft: '10px' }}
                />
              </Grid>
              <Grid
                item
                xs={12}
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <ProfileImg src={useravatar} alt="header back" />
                <ParaText
                  style={{
                    padding: '3rem 5rem',
                    textAlign: 'center',
                  }}
                >
                  Right now you support @leahx1621 the most and they will
                  receive 100 AVM at the end of the month.
                </ParaText>
              </Grid>
            </Grid>
          </RewardCard>

          <SmallRewardCard>
            <RewardCardSmallLayer></RewardCardSmallLayer>

            <Grid
              container
              sx={{
                alignItems: 'center',
              }}
            >
              <Grid
                item
                xs={6}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <TitleText style={{ fontSize: '1.4rem' }}>
                  2.
                  <LightChip
                    avatar={<Avatar alt="@leahx1621" src={useravatar} />}
                    label="@leahx1621"
                    style={{ marginLeft: '15px' }}
                  />
                </TitleText>
              </Grid>
              <Grid item xs={6} sx={{ textAlign: 'end' }}>
                <ParaText
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'end',
                    color: '#ddb930',
                    marginRight: '1rem',
                  }}
                >
                  <img
                    src={moneyIcon.default}
                    alt="money Icon"
                    width={20}
                    height={20}
                    style={{ marginRight: '.4rem' }}
                  />
                  PAYS OUT 300 AVM
                </ParaText>
              </Grid>
            </Grid>
          </SmallRewardCard>

          <SmallRewardCard>
            <Grid
              container
              sx={{
                alignItems: 'center',
              }}
            >
              <RewardCardSmallLayer></RewardCardSmallLayer>

              <Grid
                item
                xs={6}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <TitleText style={{ fontSize: '1.4rem' }}>
                  3.
                  <LightChip
                    avatar={<Avatar alt="@leahx1621" src={useravatar} />}
                    label="@leahx1621"
                    style={{ marginLeft: '15px' }}
                  />
                </TitleText>
              </Grid>
              <Grid item xs={6} sx={{ textAlign: 'end' }}>
                <ParaText
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'end',
                    color: '#ddb930',
                    marginRight: '1rem',
                  }}
                >
                  <img
                    src={moneyIcon.default}
                    alt="money Icon"
                    width={20}
                    height={20}
                    style={{ marginRight: '.4rem' }}
                  />
                  PAYS OUT 300 AVM
                </ParaText>
              </Grid>
            </Grid>
          </SmallRewardCard>

          <SmallRewardCard>
            <RewardCardSmallLayer></RewardCardSmallLayer>
            <Grid
              container
              sx={{
                alignItems: 'center',
              }}
            >
              <Grid
                item
                xs={6}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <TitleText style={{ fontSize: '1.4rem' }}>
                  4.
                  <LightChip
                    avatar={<Avatar alt="@leahx1621" src={useravatar} />}
                    label="@leahx1621"
                    style={{ marginLeft: '15px' }}
                  />
                </TitleText>
              </Grid>
              <Grid item xs={6} sx={{ textAlign: 'end' }}>
                <ParaText
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'end',
                    color: '#ddb930',
                    marginRight: '1rem',
                  }}
                >
                  <img
                    src={moneyIcon.default}
                    alt="money Icon"
                    width={20}
                    height={20}
                    style={{ marginRight: '.4rem' }}
                  />
                  PAYS OUT 300 AVM
                </ParaText>
              </Grid>
            </Grid>
          </SmallRewardCard>
        </Box>
      </ThemeProvider>
    </React.Fragment>
  );
};

export default AvmBody;
